import { useState } from "react";
import Typography from "@material-ui/core/Typography";
import { EVENTNAMES } from "helpers/constants";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { dataLayerTracking } from "gtmTracking";
import styles from "./faq.module.scss";

interface Props {
  faqData: any;
}

export const Faq: React.FC<Props> = (props) => {
  const { faqData } = props;
  const [expanded, setExpanded] = useState<string | false>(false);
  const [isfaqClicked, setIsFaqClicked] = useState<boolean>(false);
  const [faqQuestion, setFaqQuestion] = useState<string>("");

  const handleChange = (panel: string) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean
  ) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <>
      <div className={styles.expansionContainer}>
        {faqData &&
          faqData.map((faq: any, key: number) => {
            return (
              <Accordion
                expanded={expanded === "panel" + key}
                onChange={handleChange("panel" + key)}
                className={styles.panelRoot}
                key={key}
              >
                <AccordionSummary
                  onClick={() => {
                    setIsFaqClicked(!isfaqClicked);
                    if (faq.faqQuestion !== faqQuestion) {
                      dataLayerTracking({
                        event: EVENTNAMES.FREQUENT_ASK_SELECT,
                        questions_selected: faq?.faqQuestion,
                      });
                    }
                    setFaqQuestion(faq.faqQuestion);
                  }}
                  expandIcon={<ExpandMoreIcon />}
                  classes={{
                    root: styles.panelHeader,
                    content: styles.summaryContent,
                    expandIcon: styles.expandIcon,
                    expanded: styles.panelExpanded,
                  }}
                >
                  <Typography className={styles.panelHeading}>
                    {faq?.faqQuestion?.replace(/<[^>]+>/g, "")}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className={styles.panelDetails}>
                  <div className={styles.detailsContent}>
                    <Typography>
                      {faq?.faqAnswer?.replace(/<[^>]+>/g, "")}
                    </Typography>
                  </div>
                </AccordionDetails>
              </Accordion>
            );
          })}
      </div>
    </>
  );
};
export default Faq;
